import React, { useRef, useEffect } from 'react';

import Input from '@/elements/Input';
import { components } from 'react-select';
import useCountryCodes from '@/hooks/auth/useCountryCodes';

const SingleValue = ({ children, data, ...props }) => (
    <components.SingleValue {...props}>
        {data.phone_code ? `+ ${data.phone_code}` : children}
    </components.SingleValue>
);

export default function PhoneNumber({
    errors,
    onChange,
    formData,
    label = false,
    labelClass = '',
    required = false,
}) {
    const inputRef = useRef(null);
    const { data } = useCountryCodes();

    let phoneError = errors?.phone || errors?.uniquePhoneIso || errors?.phoneIso;

    // if phone error, check if array, if so, join them
    if (phoneError && Array.isArray(phoneError)) {
        phoneError = phoneError.join(' ');
    }

    if (!data) return null;

    const selectedOption = data?.find(
        (item) => item.phone_iso == formData?.phoneIso
    );

    return (
        <Input
            label={label}
            labelClass={labelClass}
            required={required}
            error={phoneError ? phoneError : null}
            inputType="custom"
        >
            <div className="flex items-flex-start phone-input">
                <div className="w-24 flex-shrink-0 ">
                    <Input
                        ref={inputRef}
                        options={data}
                        name="phoneIso"
                        required={true}
                        placeholder="+44"
                        inputType="select"
                        value={selectedOption}
                        components={{ SingleValue }}
                        defaultValue={selectedOption}
                        error={phoneError ? true : null}
                        getOptionValue={(option) => option.phone_iso}
                        getOptionLabel={(option) => option.input_label}
                        handleChange={(value) => {
                            onChange(value?.phone_iso, 'phoneIso');
                        }}
                    />
                </div>

                <Input
                    inputType="tel"
                    name="phone"
                    value={formData.phone}
                    className="grow-1 mt-0"
                    placeholder="Phone number"
                    error={phoneError ? true : null}
                    handleChange={(phone) => onChange(phone, 'phone')}
                    required={required}
                />
            </div>
        </Input>
    );
}
